import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch } from "../../store/store";

import {
  setMovements,
  setLoading,
  clearMovements
} from "../../store/slices/cash/cashMovementSlice";

import useApiErrorHandler from "../useApiErrorHandler";
import useLoading from "../useLoading";
import CashMovementService from "../../services/cash/CashMovementService";
import { CashMovementType } from "../../types/cash/CashMovementType";

export const useCashMovements = () => {

  const dispatch: AppDispatch = useDispatch();

  const { movements, loading } = useSelector(
    (state: RootState) => state.cashMovement
  );

  const { handle } = useApiErrorHandler();
  const { showLoadingIndicator, hideLoadingIndicator } = useLoading();

  /**
 * 📜 Obtener movimientos de sesión
 */
  const getSessionMovements = async (
    sessionId: number,
    types?: CashMovementType[]
  ) => {

    try {

      showLoadingIndicator();

      dispatch(setLoading(true));

      const response = await CashMovementService.getSessionMovements(
        sessionId,
        types
      );

      if (response?.statusCode === 200) {

        dispatch(setMovements(response.data));

      }

    } catch (error) {

      handle(error);

    } finally {

      hideLoadingIndicator();

      dispatch(setLoading(false));

    }

  };

  const clear = () => {
    dispatch(clearMovements());
  };

  return {

    movements,
    loading,

    getSessionMovements,
    clearMovements,
    clear

  };

};